import styled from "styled-components";

const PopupContainer = styled.span`
  display: block;
  position: absolute;
  background-color: #333333 !important;
  white-space: nowrap;
  border-radius: 4px;
  left: 50%;
  bottom: 10px;
  transform: translateX(-50%);
  line-height: 1;

  /*
   * This is because of the text indent on the scripture style
   * We should probably rethink this: .scripture [class^=p]
   * or move this outside of the <p><span>...
   */
  text-indent: 0;
  transition: all 0.3s;
  svg {
    color: #ffffff !important;
    transition: color 0.5s;
  }

  &:after {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(5, 7, 8, 0);
    border-top-color: #333333;
    border-width: 6px;
    margin-left: -6px;
  }

  & > div {
    display: flex;
  }

  div.SocialMediaShareButton {
    display: inline-block;
    /*
     * This is because of the text indent on the scripture style
     * We should probably rethink this: .scripture [class^=p]
     * or move this outside of the <p><span>...
     */
    text-indent: 0;
  }
`;

export default PopupContainer;
